import React from 'react';

function About() {
    return (
        <div className="page-container">
            <h2>About Us</h2>
            <p>We are a real estate platform helping you find the best properties based on your needs. Our app allows you to filter projects by price, type, area, and other criteria.</p>
        </div>
    );
}

export default About;
